import { fetchInboundPPH, fetchInboundDowntime, fetchQualityMetrics, fetchCubeMetrics } from "../network/InboundNetworkAPI";
import { fetchStowMetrics } from "../network/StowMetricsAPI";
import { INBOUND_ACTION_TYPES, CUBE_METRIC_NAMES } from "../../util/Constants";

export const InboundDataReducer = (state, action) => {
    switch (action.type) {
        case INBOUND_ACTION_TYPES.LOAD_INBOUND_DATA:
            const { dispatcher, timeRange, timeSeriesGranularity, isCubeMetricsEnabled } = action.payload;
            fetchInboundPPH(dispatcher, timeRange, timeSeriesGranularity);
            fetchInboundDowntime(dispatcher, timeRange);
            fetchQualityMetrics(dispatcher, timeRange);
            fetchStowMetrics(dispatcher);
            if (isCubeMetricsEnabled) {
                fetchCubeMetrics(dispatcher, timeRange, CUBE_METRIC_NAMES);
            }
            // Only set loading to true if we don't already have data (initial load).
            // On refresh, keep showing existing data while fetching new data.
            const isInitialLoad = !state.pphData && !state.downtimeData;
            return {
                ...state,
                loading: isInitialLoad,
                error: null,
                stowMetricsError: null,
                qualityDataError: null,
                cubeMetricsError: null
            };

        case INBOUND_ACTION_TYPES.RECEIVE_PPH_DATA:
            return {
                ...state,
                pphData: action.data,
                loading: state.downtimeData ? false : state.loading,
                lastSuccessfulFetch: Date.now()
            };

        case INBOUND_ACTION_TYPES.RECEIVE_DOWNTIME_DATA:
            return {
                ...state,
                downtimeData: action.data,
                loading: state.pphData ? false : state.loading,
                lastSuccessfulFetch: Date.now()
            };

        case INBOUND_ACTION_TYPES.RECEIVE_STOW_METRICS:
            return {
                ...state,
                stowMetrics: action.data,
                stowMetricsError: null
            };

        case INBOUND_ACTION_TYPES.RECEIVE_QUALITY_DATA:
            return {
                ...state,
                qualityData: action.data,
                qualityDataError: null
            };

        case INBOUND_ACTION_TYPES.QUALITY_DATA_FAILURE:
            // Only show error if no existing quality data (preserves stale data on refresh failure)
            return {
                ...state,
                qualityDataError: state.qualityData ? null : action.error
            };

        case INBOUND_ACTION_TYPES.STOW_METRICS_FAILURE:
            // Only show error if no existing stow metrics (preserves stale data on refresh failure)
            return {
                ...state,
                stowMetricsError: state.stowMetrics ? null : action.error
            };

        case INBOUND_ACTION_TYPES.RECEIVE_CUBE_METRICS:
            return {
                ...state,
                cubeMetrics: action.data,
                cubeMetricsError: null
            };

        case INBOUND_ACTION_TYPES.CUBE_METRICS_FAILURE:
            // Only show error if no existing cube metrics (preserves stale data on refresh failure)
            return {
                ...state,
                cubeMetricsError: state.cubeMetrics ? null : action.error
            };

        case INBOUND_ACTION_TYPES.CUBE_METRICS_UNAVAILABLE:
            // Feature-flag lookup failed, so we can't confirm the feature is enabled.
            // Treat the section as absent (clear any error so no banner shows) while
            // preserving already-loaded data. Real API failures use CUBE_METRICS_FAILURE.
            return {
                ...state,
                cubeMetricsError: null
            };

        case INBOUND_ACTION_TYPES.API_FAILURE:
            // If we already have data loaded, preserve it and don't show the error
            // (e.g., session token expired during auto-refresh).
            // Only show error if this is the initial load with no existing data.
            const hasExistingData = state.pphData || state.downtimeData;
            return {
                ...state,
                loading: false,
                error: hasExistingData ? null : action.error
            };

        case INBOUND_ACTION_TYPES.CLEAR_DATA:
            return {
                ...state,
                pphData: null,
                downtimeData: null,
                qualityData: null,
                qualityDataError: null,
                stowMetrics: null,
                stowMetricsError: null,
                cubeMetrics: null,
                cubeMetricsError: null,
                loading: false,
                error: null
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/inbound/reducers/InboundDataReducer.js